import React, { useContext } from "react";
import { Box } from "@mui/material";
import Logo from "../components/Logo";
import Profile from "../components/Profile";
import { AuthContext } from "../contexts/AuthContext";
import AuthModal from "../modals/AuthModal";

const Header = () => {
  const { loggedIn, isLoggedIn, setLoggedIn, setIsLoggedIn, initialUser } =
    useContext(AuthContext);

  let logoutTimeout;

  const handleLogout = () => {
    // Perform logout logic here
    clearTimeout(logoutTimeout);
    logoutTimeout = setTimeout(logoutUser, 5 * 60 * 1000);
  };

  const handleLogoutButton = () => {
    // Perform logout logic here
    setLoggedIn(false);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    sessionStorage.clear();
    setIsLoggedIn(initialUser);
  };

  const logoutUser = () => {
    setLoggedIn(false);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    sessionStorage.clear();
    setIsLoggedIn(initialUser);
  };
  document.addEventListener("mousemove", handleLogout);
  document.addEventListener("keypress", handleLogout);

  return (
    <>
      {loggedIn && (
        <Box
          sx={{
            width: "100%",
            position: "fixed",
            top: 0,
            left: "50%",
            display: "flex",
            transform: "translateX(-50%)",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "1rem",
            paddingTop: "0.25rem",
            paddingBottom: "0.25rem",
            backdropFilter: "blur(1rem)",
            boxShadow: "0 0 1rem rgba(0, 0, 0, 0.2)",
          }}
        >
          <Logo height={40} />
          <Profile
            handleLogoutButton={handleLogoutButton}
            profileImage={isLoggedIn.image}
            firstName={isLoggedIn.firstName}
            email={isLoggedIn.email}
            accessLevel={isLoggedIn.accessLevel}
            initials={isLoggedIn.initials}
          />
        </Box>
      )}
      {!loggedIn && <AuthModal />}
    </>
  );
};

export default Header;
